import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import SpreadSheet from '../../../../../../components/SpreadSheet'

import { GEO_DISTRIBUTION } from '../../../fields'
import useCommonStyles from '../../../../../../styles/common/listPage'

import useTableStyles from '../tableStyles'

const spreadSheetGeoDistributionColumnLabels = ['Country', 'Percentage (%)']

const GeoDistributionRow = ({ formik }) => {
  const commonClasses = useCommonStyles()
  const tableClasses = useTableStyles()
  const { values, errors, setFieldValue, touched } = formik

  const { t } = useTranslation()

  const showGeoDistributionError = touched[GEO_DISTRIBUTION] && errors[GEO_DISTRIBUTION]

  const errorRowsIndexes = useMemo(() => {
    if (!showGeoDistributionError) return []

    return values[GEO_DISTRIBUTION].map((row, index) => {
      const percentageValue = row[1] && row[1].value !== undefined ? parseFloat(row[1].value) : null
      return percentageValue !== null && (isNaN(percentageValue) || percentageValue < 0 || percentageValue > 100)
        ? index
        : null
    }).filter(index => index !== null)
  }, [showGeoDistributionError, values])

  return (
    <div className={commonClasses.formRow}>
      <FieldLabelWrapper label={t('Geo distribution')} labelFor={GEO_DISTRIBUTION}>
        <SpreadSheet
          name={GEO_DISTRIBUTION}
          setFieldValue={setFieldValue}
          formikData={values[GEO_DISTRIBUTION]}
          columnLabels={spreadSheetGeoDistributionColumnLabels}
          maxRows={500}
          tableClassName={tableClasses.spreadSheetTable}
          error={showGeoDistributionError}
          errorRowsIndexes={errorRowsIndexes}
        />
      </FieldLabelWrapper>
    </div>
  )
}

export default GeoDistributionRow
